/** True when focus is likely inside text entry (avoid global shortcuts). */
export function isTextEditingTarget(target: EventTarget | null): boolean {
  if (!(target instanceof HTMLElement)) return false;
  const tag = target.tagName;
  if (tag === "INPUT" || tag === "TEXTAREA" || tag === "SELECT") return true;
  if (target.isContentEditable) return true;
  if (target.closest(".ProseMirror, .manuscript-prose, [contenteditable='true']")) return true;
  return false;
}
